module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    staticStyle: {
      "background-image": "url(images/shapes_g.jpg)",
      "background-repeat": "no-repeat",
      "background-position": "left left"
    },
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REFACE TO THE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECOND")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_c('i', [_c('b', [_vm._v("1")])]), _vm._v(" Where Do I Start?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2"
    }
  }, [_c('i', [_c('b', [_vm._v("2")])]), _vm._v(" What Is Real?"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("Metaphysics")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("3")])]), _vm._v(" How Do I Know?"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("Epistemology")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("4")])]), _vm._v(" How Should I Live?"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("Ethics")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("5")])]), _vm._v(" What Am I?"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("Philosophical and Theological Anthropology")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("6")])]), _vm._v(" How Should Christians Think About Science?"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("Philosophy of Science")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("7")])]), _vm._v(" What Is Beauty? What About Art?"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("Aesthetics")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("8")])]), _vm._v(" What Should We Worship?"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("Philosophy of Religion")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_c('b', [_vm._v("9")])]), _vm._v(" Where Do I Go from Here?"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("Worldview Struggle and Intellectual Crisis")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OR")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URTHER")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EADING")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBJECT")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTES")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAISE FOR")]), _vm._v(" "), _c('i', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILOSOPHY")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LIGHTLY")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESS")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFFICULT")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOUT THE ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHORS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITLES FROM")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERVARSITY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESS")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 60
// module chunks = 0